import { configureStore } from '@reduxjs/toolkit';
import { createLandingApi } from '../api';
import { IApplicationContext } from '../types/applicationContext';
import { IPreloadedState } from '../types/redux';
import { dictionariesSlice } from './dictionariesSlice';
import { landingSlice } from './landingSlice';
import { userSlice } from './userSlice';

export const createReduxStore = (context: IApplicationContext, preloadedState: IPreloadedState, devTools: boolean) => {
  const landingApi = createLandingApi(context);

  return configureStore({
    reducer: {
      [landingApi.reducerPath]: landingApi.reducer,
      [landingSlice.name]: landingSlice.reducer,
      [dictionariesSlice.name]: dictionariesSlice.reducer,
      [userSlice.name]: userSlice.reducer,
    },
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware({
        //FIXME отключил предупреждение сериализации - так как редукс ругается что передаем реакт-ref из событий
        //https://redux-toolkit.js.org/usage/usage-guide#working-with-non-serializable-data
        serializableCheck: {
          ignoreActions: true,
        },
        thunk: { extraArgument: context },
      }).concat(landingApi.middleware),
    preloadedState,
    devTools,
  });
};

export type TReduxStore = ReturnType<typeof createReduxStore>;
export type TApplicationState = ReturnType<TReduxStore['getState']>;
export type TDispatch = TReduxStore['dispatch'];

export interface IThunkApi {
  state: TApplicationState;
  extra: IApplicationContext;
  dispatch: TDispatch;
}

export type TCreateStoreFunctionSignature = typeof createReduxStore;
